import { Injectable } from '@angular/core';
import { Storage } from "@ionic/storage";

@Injectable()
export class StorageService {

    constructor(private storage: Storage) {
    }

    getTelNum() {
        var self = this;
        return this.storage.get('telephone_number').then((result) => {
            console.log("getTelNum ->", result);
            return result;
        });
    }

    async getUser() {
        return await this.storage.get('user');
    }

    async getToken() {
        return await this.storage.get('token');
    }

    setTelNum(telephone_number) {
        this.storage.set('telephone_number', telephone_number);
    }

    async setUser(user) {
        return await this.storage.set('user', user);
    }

    async setToken(token) {
        return this.storage.set('token', token);
    }

    unsetTelNum() {
        this.storage.remove('telephone_number');
    }

    unsetUser() {
        this.storage.remove('user');
        this.storage.remove('token');
        this.storage.remove('currentProject');
        this.storage.remove('myReports');
        this.storage.clear();
    }

    setCurrentProject(project) {
        return this.storage.set('currentProject', project);
    }

    async getCurrentProject() {
        return await this.storage.get('currentProject');
    }

    async setSpeciesTypesList(speciesTypes) {
        return await this.storage.set('speciesTypesList', speciesTypes);
    }

    async getSpeciesTypesList() {
        return await this.storage.get('speciesTypesList');
    }

    async setSpeciesList(speciesTypes) {
        return await this.storage.set('speciesList', speciesTypes);
    }

    async getSpeciesList() {
        return await this.storage.get('speciesList');
    }

    async setMyReports(myReports) {
        return await this.storage.set('myReports', myReports);
    }

    async getMyReports() {
        return await this.storage.get('myReports');
    }

    async addOfflineReport(payload) {
        let reports: any[] = await this.storage.get('draftReports');

        if (!reports)
            reports = [];
        let edit = false;

        //console.log("offlineReports: ", reports);
        if (reports && reports.length > 0) {
            for (let i = 0; i <= reports.length; i++) {
                if (reports[i].draft_id == payload.draft_id) {
                    reports[i] = payload;
                    edit = true;
                }
            }
        }
        if (!edit)
            reports.push(payload);
        return await this.storage.set('draftReports', reports);
    }

    async removeOfflineReport(draftId) {
        let reports: any[] = await this.storage.get('draftReports');
        let draftReports = [];
        for (let report of reports) {
            if (report.draft_id == draftId) continue;
            draftReports.push(report);
        }
        return await this.storage.set('draftReports', draftReports);
    }

    async getDraftReports() {
        return await this.storage.get('draftReports');
    }

}
